import {
    favoritesLeftNavItemId,
    contactsLeftNavItemId,
    contactListsLeftNavItemId,
    rootContactFolderDistinguishedName,
    deletedItemsLeftNavItemId,
    joinedUnifiedGroupsLeftNavId,
    ownedUnifiedGroupsLeftNavId,
    deletedUnifiedGroupsLeftNavId,
} from '..';
import type { ContactFoldersState } from '../../appstate';
import { Md5 } from 'ts-md5/dist/md5';

export enum LeftNavItemType {
    Root = 'Root',
    Favorite = 'Favorite',
    Default = 'Default',
    DisplayedFolder = 'DisplayedFolder',
    Contacts = 'Contacts',
    ContactLists = 'ContactLists',
    DeletedItems = 'DeletedItems',
    DeletedFolder = 'DeletedFolder',
    JoinedGroups = 'JoinedGroups',
    OwnedGroups = 'OwnedGroups',
    DeletedGroups = 'DeletedGroups',
    PublicFolder = 'PublicFolder',
    Directory = 'Directory',
    Unknown = 'Unknown',
}

export const getLeftNavItemType = (
    leftNavItemId: string,
    contactFolderState: ContactFoldersState
) => {
    if (leftNavItemId === favoritesLeftNavItemId) {
        return LeftNavItemType.Favorite;
    } else if (
        contactFolderState?.rootContactFolder &&
        leftNavItemId === contactFolderState.rootContactFolder.id
    ) {
        return LeftNavItemType.Root;
    } else if (
        contactFolderState?.defaultContactFolder &&
        leftNavItemId === contactFolderState.defaultContactFolder.id
    ) {
        return LeftNavItemType.Default;
    } else if (leftNavItemId === contactsLeftNavItemId) {
        return LeftNavItemType.Contacts;
    } else if (leftNavItemId === contactListsLeftNavItemId) {
        return LeftNavItemType.ContactLists;
    } else if (
        contactFolderState &&
        contactFolderState.displayedContactFolders.some(folder => folder.id === leftNavItemId)
    ) {
        return LeftNavItemType.DisplayedFolder;
    } else if (
        contactFolderState?.publicFolders &&
        contactFolderState.publicFolders.some(folder => folder.id === leftNavItemId)
    ) {
        return LeftNavItemType.PublicFolder;
    } else if (leftNavItemId === deletedItemsLeftNavItemId) {
        return LeftNavItemType.DeletedItems;
    } else if (leftNavItemId === joinedUnifiedGroupsLeftNavId) {
        return LeftNavItemType.JoinedGroups;
    } else if (leftNavItemId === ownedUnifiedGroupsLeftNavId) {
        return LeftNavItemType.OwnedGroups;
    } else if (leftNavItemId === deletedUnifiedGroupsLeftNavId) {
        return LeftNavItemType.DeletedGroups;
    } else if (
        contactFolderState?.sparseFolders &&
        contactFolderState.sparseFolders.some(folder => folder.id === leftNavItemId)
    ) {
        return LeftNavItemType.Directory;
    }

    return LeftNavItemType.Unknown;
};

export const hashFolderId = (folderId: string) => {
    if (!folderId) {
        return '0';
    }

    switch (folderId) {
        case rootContactFolderDistinguishedName:
        case favoritesLeftNavItemId:
        case contactsLeftNavItemId:
        case contactListsLeftNavItemId:
        case deletedItemsLeftNavItemId:
            return folderId;

        default:
            return Md5.hashAsciiStr(folderId) as string;
    }
};
